/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var CheckCircleIcon24Solid = forwardRef('CheckCircleIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Zm6.421-12.613a1.25 1.25 0 1 0-1.767-1.767l-6.142 6.141a.25.25 0 0 1-.353 0l-2.432-2.432a1.25 1.25 0 0 0-1.768 1.768l2.432 2.432a2.75 2.75 0 0 0 3.89 0l6.14-6.142Z" })));
});
